import { ChecklistIcon } from '@THC/components/Icons';
import { IconText } from '@THC/components/IconText';
import { MDText } from 'i18n-react';

import { useOptimizelyEarlyDocumentsExperimentDecision } from 'Services/optimizely/experimentations/useEarlyDocumentsExperimentation';
import { TRACKING_ATTRIBUTE_NAME } from 'Utilities/hooks/useTrackElementVisibleOnce';

import LocalTexts from '../../EarlyDocuments.texts';

import { TAG_NAME } from './EarlyDocumentsBadge.events';

import styles from './EarlyDocumentsBadge.module.scss';

const LocalT = new MDText(LocalTexts);

interface EarlyDocumentsBadgeProps {
	hasEarlyDocuments: boolean;
	id: number;
	isPaidListing: boolean;
}

export const EarlyDocumentsBadge = ({ hasEarlyDocuments, id, isPaidListing }: EarlyDocumentsBadgeProps) => {
	const isEnabled = useOptimizelyEarlyDocumentsExperimentDecision({ hasEarlyDocuments, id, isPaidListing });
	return isEnabled ? (
		<div className={styles.container} {...{ [TRACKING_ATTRIBUTE_NAME]: TAG_NAME }}>
			<IconText icon={ChecklistIcon} text={LocalT.translate('badge')} variant="xsmall--regular" />
		</div>
	) : null;
};
